// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { jwtDecode } from "jwt-decode";

// const LeaveApproval = () => {
//   // State for leave requests
//   const [leaveRequests, setLeaveRequests] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // State for filters
//   const [filters, setFilters] = useState({
//     status: 'All',
//     department: 'All'
//   });

//   // State for search query
//   const [searchQuery, setSearchQuery] = useState('');
  
//   // State for departments
//   const [departments, setDepartments] = useState(['All']);

//   // State for selected request
//   const [selectedRequest, setSelectedRequest] = useState(null);

//   // Handle filter changes
//   const handleFilterChange = (filterType, value) => {
//     setFilters({
//       ...filters,
//       [filterType]: value
//     });
//   };

//   // Handle search input change
//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   // Fetch leave requests from API


// const fetchLeaveRequests = async () => {
//   setLoading(true);
//   setError(null);

//   const token = localStorage.getItem("authToken") || localStorage.getItem("token");
//   if (!token) {
//     setError("No access token found. Please log in.");
//     setLoading(false);
//     return;
//   }

//   let decoded;
//   try {
//     decoded = jwtDecode(token);
//   } catch (err) {
//     console.error("Invalid token:", err);
//     setError("Invalid token. Please log in again.");
//     setLoading(false);
//     return;
//   }

//   // Extract companyId from token payload
//   const companyId = decoded.companyId || decoded.id;
//   if (!companyId) {
//     setError("No companyId found in token.");
//     setLoading(false);
//     return;
//   }

//   try {
//     const response = await axios.get("https://customersupport-jhy9.onrender.com/api/leaves", {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       params: {
//         company: companyId,
//       },
//     });

//     console.log("Leave requests API response:", response.data);

//     let leaves = [];
//     if (response.data && Array.isArray(response.data)) {
//       leaves = response.data;
//     } else if (response.data.leaves && Array.isArray(response.data.leaves)) {
//       leaves = response.data.leaves;
//     }

//     const formattedRequests = await Promise.all(
//       leaves.map(async (leave) => {
//         const fromDate = new Date(leave.fromDate);
//         const toDate = new Date(leave.toDate);
//         const timeDiff = toDate.getTime() - fromDate.getTime();
//         const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + 1;

//         const appliedDate = leave.appliedDate || leave.createdAt;
//         const formattedAppliedDate = appliedDate
//           ? new Date(appliedDate).toLocaleDateString("en-GB", {
//               day: "2-digit",
//               month: "2-digit",
//               year: "numeric",
//             })
//           : "N/A";

//         let employeeDetails = null;

//         if (leave.employee && (leave.employee._id || leave.employee)) {
//           const employeeId = leave.employee._id || leave.employee;
//           try {
//             const employeeResponse = await axios.get(
//               `https://customersupport-jhy9.onrender.com/api/employees/${employeeId}`,
//               {
//                 headers: {
//                   "Content-Type": "application/json",
//                   Authorization: `Bearer ${token}`,
//                 },
//               }
//             );
//             employeeDetails = employeeResponse.data;
//             console.log(`Employee details for ${employeeId}:`, employeeDetails);

//             if (
//               employeeDetails?.department &&
//               typeof employeeDetails.department === "string"
//             ) {
//               try {
//                 const deptResponse = await axios.get(
//                   `https://customersupport-jhy9.onrender.com/api/departments/${employeeDetails.department}`,
//                   {
//                     headers: {
//                       "Content-Type": "application/json",
//                       Authorization: `Bearer ${token}`,
//                     },
//                   }
//                 );
//                 employeeDetails.departmentDetails = deptResponse.data;
//                 console.log(
//                   `Department details for ${employeeDetails.department}:`,
//                   deptResponse.data
//                 );
//               } catch (deptErr) {
//                 console.error(
//                   `Error fetching department ${employeeDetails.department}:`,
//                   deptErr
//                 );
//               }
//             }
//           } catch (employeeErr) {
//             console.error(`Error fetching employee ${employeeId}:`, employeeErr);
//           }
//         }

//         return {
//           id: leave._id,
//           teamMemberName:
//             employeeDetails?.teamMemberName ||
//             employeeDetails?.name ||
//             leave.employee?.teamMemberName ||
//             leave.employee?.name ||
//             (employeeDetails?.firstName && employeeDetails?.lastName
//               ? `${employeeDetails.firstName} ${employeeDetails.lastName}`
//               : leave.employee?.firstName && leave.employee?.lastName
//               ? `${leave.employee.firstName} ${leave.employee.lastName}`
//               : "Unknown Employee"),
//           employeeId:
//             employeeDetails?._id || leave.employee?._id || "N/A",
//           department:
//             employeeDetails?.departmentDetails?.name ||
//             employeeDetails?.departmentDetails?.departmentName ||
//             employeeDetails?.department?.name ||
//             (typeof employeeDetails?.department === "string"
//               ? "Loading..."
//               : employeeDetails?.department) ||
//             leave.employee?.department?.name ||
//             leave.employee?.department ||
//             "N/A",
//           type: leave.leaveType || "Leave",
//           startDate: leave.fromDate,
//           endDate: leave.toDate,
//           days: daysDiff > 0 ? daysDiff : 1,
//           duration: `${daysDiff > 0 ? daysDiff : 1} day${
//             daysDiff > 1 ? "s" : ""
//           }`,
//           status: leave.status || "pending",
//           reason: leave.reason || "No reason provided",
//           appliedOn: formattedAppliedDate,
//           attachment: leave.attachment || null,
//           contact:
//             employeeDetails?.emergencyMobileNumber ||
//             employeeDetails?.phone ||
//             employeeDetails?.contact ||
//             leave.employee?.phone ||
//             leave.employee?.emergencyMobileNumber ||
//             leave.employee?.contact ||
//             "N/A",
//           emergencyMobileNumber:
//             employeeDetails?.emergencyMobileNumber ||
//             leave.employee?.emergencyMobileNumber ||
//             "N/A",
//           email:
//             employeeDetails?.email ||
//             leave.employee?.email ||
//             "N/A",
//           fullEmployeeDetails: employeeDetails,
//         };
//       })
//     );

//     setLeaveRequests(formattedRequests);
//     console.log("Formatted leave requests:", formattedRequests);
//   } catch (err) {
//     console.error("Error fetching leave requests:", err);
//     setError("Failed to load leave requests. Please try again.");
//   } finally {
//     setLoading(false);
//   }
// };


//   // Fetch leave requests on component mount
//   useEffect(() => {
//     fetchLeaveRequests();
//   }, []);

//   // Handle approval action
//   const handleApprove = async (id) => {
//     try {
//       const token = localStorage.getItem('authToken') || localStorage.getItem('token');
      
//       if (!token) {
//         setError('Authentication token not found. Please login again.');
//         return;
//       }

//       console.log('🎯 APPROVING LEAVE REQUEST:', {
//         leaveRequestId: id,
//         timestamp: new Date().toISOString()
//       });
      
//       // Decode JWT token to get approver details
//       let approverId, approverRole, approverName, companyId;
//       try {
//         const decoded = jwtDecode(token);
//         console.log('🔍 APPROVER TOKEN DECODING:', {
//           fullToken: decoded,
//           id: decoded.id,
//           role: decoded.role,
//           name: decoded.name || decoded.username,
//           companyId: decoded.companyId
//         });
        
//         approverId = decoded.id || decoded._id || decoded.userId;
//         approverRole = decoded.role || 'Admin';
//         approverName = decoded.name || decoded.username || decoded.teamMemberName || 'Admin';
//         companyId = decoded.companyId || decoded.company?._id || decoded.orgId;
        
//         console.log('├── Approver ID:', approverId);
//         console.log('├── Approver Role:', approverRole);
//         console.log('├── Approver Name:', approverName);
//         console.log('└── Company ID:', companyId);
//       } catch (decodeError) {
//         console.error('❌ Error decoding token:', decodeError);
//         setError('Invalid authentication token. Please login again.');
//         localStorage.removeItem('authToken');
//         return;
//       }

//       // Comprehensive approval data structure
//       const approvalData = {
//         status: 'Approved',
//         approvedBy: approverId,
//         approvedAt: new Date().toISOString(),
//         approverRole: approverRole,
//         approverName: approverName,
//         companyId: companyId,
//         approvalHistory: {
//           action: 'approved',
//           actionBy: approverId,
//           actionByName: approverName,
//           actionByRole: approverRole,
//           actionAt: new Date().toISOString(),
//           comments: `Leave request approved by ${approverName} (${approverRole})`
//         }
//       };

//       console.log('📤 SENDING APPROVAL DATA:', approvalData);
      
//       const response = await axios.put(
//         `https://customersupport-jhy9.onrender.com/api/leaves/${id}/status`,
//         approvalData,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}`
//           },
//           validateStatus: (status) => status < 500
//         }
//       );
      
//       console.log('✅ SUCCESS RESPONSE:', {
//         status: response.status,
//         statusText: response.statusText,
//         data: response.data
//       });

//       if (response.status === 401) {
//         console.error('🚫 Session expired during approval');
//         localStorage.removeItem('authToken');
//         setError('Session expired. Please login again.');
//         window.location.href = '/login';
//         return;
//       }
      
//       // Update local state with comprehensive approval information
//       setLeaveRequests(prevRequests => 
//         prevRequests.map(request => 
//           request.id === id ? { 
//             ...request, 
//             status: 'Approved',
//             approvedBy: approverName,
//             approvedAt: new Date().toISOString(),
//             approverRole: approverRole
//           } : request
//         )
//       );
      
//       // Show success message with approver details
//       setError('');
//       alert(`Leave request approved successfully by ${approverName} (${approverRole})!`);
      
//     } catch (err) {
//       console.error('❌ ERROR APPROVING LEAVE:', {
//         error: err.message,
//         status: err.response?.status,
//         statusText: err.response?.statusText,
//         data: err.response?.data,
//         fullError: err
//       });
      
//       if (err.response?.status === 401) {
//         console.error('🚫 Authentication failed - cleaning up token');
//         localStorage.removeItem('authToken');
//         setError('Session expired. Please login again.');
//         window.location.href = '/login';
//       } else {
//         setError('Failed to approve leave. Please try again.');
//         alert(`Failed to approve leave request: ${err.response?.data?.message || err.message}`);
//       }
//     }
//   };

//   // Handle rejection action
//   const handleReject = async (id) => {
//     // Prompt for rejection reason
//     const rejectionReason = prompt('Please provide a reason for rejecting this leave request:');
    
//     if (!rejectionReason || rejectionReason.trim() === '') {
//       alert('Rejection reason is required.');
//       return;
//     }

//     try {
//       const token = localStorage.getItem('authToken') || localStorage.getItem('token');
      
//       if (!token) {
//         setError('Authentication token not found. Please login again.');
//         return;
//       }

//       console.log('🎯 REJECTING LEAVE REQUEST:', {
//         leaveRequestId: id,
//         rejectionReason: rejectionReason,
//         timestamp: new Date().toISOString()
//       });
      
//       // Decode JWT token to get rejector details
//       let rejectorId, rejectorRole, rejectorName, companyId;
//       try {
//         const decoded = jwtDecode(token);
//         console.log('🔍 REJECTOR TOKEN DECODING:', {
//           fullToken: decoded,
//           id: decoded.id,
//           role: decoded.role,
//           name: decoded.name || decoded.username,
//           companyId: decoded.companyId
//         });
        
//         rejectorId = decoded.id || decoded._id || decoded.userId;
//         rejectorRole = decoded.role || 'Admin';
//         rejectorName = decoded.name || decoded.username || decoded.teamMemberName || 'Admin';
//         companyId = decoded.companyId || decoded.company?._id || decoded.orgId;
        
//         console.log('├── Rejector ID:', rejectorId);
//         console.log('├── Rejector Role:', rejectorRole);
//         console.log('├── Rejector Name:', rejectorName);
//         console.log('├── Rejection Reason:', rejectionReason);
//         console.log('└── Company ID:', companyId);
//       } catch (decodeError) {
//         console.error('❌ Error decoding token:', decodeError);
//         setError('Invalid authentication token. Please login again.');
//         localStorage.removeItem('authToken');
//         return;
//       }

//       // Comprehensive rejection data structure
//       const rejectionData = {
//         status: 'Rejected',
//         rejectedBy: rejectorId,
//         rejectedAt: new Date().toISOString(),
//         rejectorRole: rejectorRole,
//         rejectorName: rejectorName,
//         rejectionReason: rejectionReason.trim(),
//         companyId: companyId,
//         approvalHistory: {
//           action: 'rejected',
//           actionBy: rejectorId,
//           actionByName: rejectorName,
//           actionByRole: rejectorRole,
//           actionAt: new Date().toISOString(),
//           comments: rejectionReason.trim()
//         }
//       };

//       console.log('📤 SENDING REJECTION DATA:', rejectionData);
      
//       const response = await axios.put(
//         `https://customersupport-jhy9.onrender.com/api/leaves/${id}/status`,
//         rejectionData,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}`
//           },
//           validateStatus: (status) => status < 500
//         }
//       );
      
//       console.log('✅ SUCCESS RESPONSE:', {
//         status: response.status,
//         statusText: response.statusText,
//         data: response.data
//       });

//       if (response.status === 401) {
//         console.error('🚫 Session expired during rejection');
//         localStorage.removeItem('authToken');
//         setError('Session expired. Please login again.');
//         window.location.href = '/login';
//         return;
//       }
      
//       // Update local state with comprehensive rejection information
//       setLeaveRequests(prevRequests => 
//         prevRequests.map(request => 
//           request.id === id ? { 
//             ...request, 
//             status: 'Rejected',
//             rejectedBy: rejectorName,
//             rejectedAt: new Date().toISOString(),
//             rejectorRole: rejectorRole,
//             rejectionReason: rejectionReason.trim()
//           } : request
//         )
//       );
      
//       // Show success message with rejector details
//       setError('');
//       alert(`Leave request rejected successfully by ${rejectorName} (${rejectorRole})!`);
      
//     } catch (err) {
//       console.error('❌ ERROR REJECTING LEAVE:', {
//         error: err.message,
//         status: err.response?.status,
//         statusText: err.response?.statusText,
//         data: err.response?.data,
//         fullError: err
//       });
      
//       if (err.response?.status === 401) {
//         console.error('🚫 Authentication failed - cleaning up token');
//         localStorage.removeItem('authToken');
//         setError('Session expired. Please login again.');
//         window.location.href = '/login';
//       } else {
//         setError('Failed to reject leave. Please try again.');
//         alert(`Failed to reject leave request: ${err.response?.data?.message || err.message}`);
//       }
//     }
//   };

//   // Handle view details
//   const handleViewDetails = (request) => {
//     setSelectedRequest(request);
//   };

//   // Close details view
//   const handleCloseDetails = () => {
//     setSelectedRequest(null);
//   };

//   // Filter and search leave requests
//   const filteredRequests = leaveRequests.filter(request => {
//     // Apply filters
//     const statusMatch = filters.status === 'All' || request.status === filters.status;
//     const departmentMatch = filters.department === 'All' || request.department === filters.department;
    
//     // Apply search query
//     const searchMatch = searchQuery === '' || 
//       request.teamMemberName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       request.employeeId.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       request.department.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       request.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       request.reason.toLowerCase().includes(searchQuery.toLowerCase());
    
//     return statusMatch && departmentMatch && searchMatch;
//   });

//   // Count requests by status (case insensitive)
//   const pendingCount = leaveRequests.filter(req => 
//     req.status && req.status.toLowerCase() === 'pending'
//   ).length;
//   const approvedCount = leaveRequests.filter(req => 
//     req.status && req.status.toLowerCase() === 'approved'
//   ).length;
//   const rejectedCount = leaveRequests.filter(req => 
//     req.status && req.status.toLowerCase() === 'rejected'
//   ).length;

//   // Get status badge color
//   const getStatusColor = (status) => {
//     switch(status) {
//       case 'Approved': return '#4caf50';
//       case 'Pending': return '#ff9800';
//       case 'Rejected': return '#f44336';
//       default: return '#9e9e9e';
//     }
//   };

//   // Fetch departments for the selected company

// useEffect(() => {
//   const fetchDepartments = async () => {
//     const token = localStorage.getItem("authToken") || localStorage.getItem("token");

//     if (!token) {
//       console.error("No access token found. Please log in.");
//       return;
//     }

//     let companyId;
//     try {
//       const decoded = jwtDecode(token);
//       companyId = decoded.companyId || decoded.id; // adjust based on your backend payload
//     } catch (err) {
//       console.error("Error decoding token:", err);
//       return;
//     }

//     if (!companyId) {
//       console.error("No companyId found in token.");
//       return;
//     }

//     try {
//       const response = await axios.get(
//         `https://customersupport-jhy9.onrender.com/api/departments/company/${companyId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data && Array.isArray(response.data)) {
//         // Extract department names from the response
//         const departmentNames = response.data.map(
//           (dept) => dept.name || dept.departmentName
//         );
//         setDepartments(["All", ...new Set(departmentNames)]);
//       } else {
//         // Fallback to unique departments from leave requests
//         const uniqueDepts = [
//           "All",
//           ...new Set(leaveRequests.map((req) => req.department)),
//         ];
//         setDepartments(
//           uniqueDepts.filter((dept) => dept !== null && dept !== undefined)
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching departments:", error);
//       // Fallback to unique departments from leave requests if API call fails
//       const uniqueDepts = [
//         "All",
//         ...new Set(leaveRequests.map((req) => req.department)),
//       ];
//       setDepartments(
//         uniqueDepts.filter((dept) => dept !== null && dept !== undefined)
//       );
//     }
//   };

//   fetchDepartments();
// }, [leaveRequests]);



//   return (
//     <div style={styles.container}>
//       <h2 style={styles.heading}>Leave Approval Dashboard</h2>
      
//       {/* Loading and Error States */}
//       {loading && <div style={styles.loading}>Loading leave requests...</div>}
//       {error && <div style={styles.error}>{error}</div>}
      
//       {/* Stats Overview */}
//       <div style={styles.statsContainer}>
//         <div style={styles.statCard}>
//           <h3 style={styles.statNumber}>{pendingCount}</h3>
//           <p style={styles.statLabel}>Pending Requests</p>
//         </div>
//         <div style={styles.statCard}>
//           <h3 style={styles.statNumber}>{approvedCount}</h3>
//           <p style={styles.statLabel}>Approved</p>
//         </div>
//         <div style={styles.statCard}>
//           <h3 style={styles.statNumber}>{rejectedCount}</h3>
//           <p style={styles.statLabel}>Rejected</p>
//         </div>
//         <div style={styles.statCard}>
//           <h3 style={styles.statNumber}>{leaveRequests.length}</h3>
//           <p style={styles.statLabel}>Total Requests</p>
//         </div>
//       </div>

//       {/* Search Box */}
//       <div style={styles.searchContainer}>
//         <div style={styles.searchBox}>
//           <span style={styles.searchIcon}>🔍</span>
//           <input
//             type="text"
//             placeholder="Search by employee name, ID, department, leave type or reason..."
//             value={searchQuery}
//             onChange={handleSearchChange}
//             style={styles.searchInput}
//           />
//           {searchQuery && (
//             <button 
//               onClick={() => setSearchQuery('')}
//               style={styles.clearSearchButton}
//             >
//               ×
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Filters */}
//       <div style={styles.filtersContainer}>
//         <h3 style={styles.filterHeading}>Filters</h3>
//         <div style={styles.filterRow}>
//           <div style={styles.filterGroup}>
//             <label style={styles.filterLabel}>Status</label>
//             <select 
//               value={filters.status} 
//               onChange={(e) => handleFilterChange('status', e.target.value)}
//               style={styles.filterSelect}
//             >
//               <option value="All">All Statuses</option>
//               <option value="Pending">Pending</option>
//               <option value="Approved">Approved</option>
//               <option value="Rejected">Rejected</option>
//             </select>
//           </div>
          
//           <div style={styles.filterGroup}>
//             <label style={styles.filterLabel}>Department</label>
//             <select 
//               value={filters.department} 
//               onChange={(e) => handleFilterChange('department', e.target.value)}
//               style={styles.filterSelect}
//             >
//               {departments.map(dept => (
//                 <option key={dept} value={dept}>{dept}</option>
//               ))}
//             </select>
//           </div>
          
//         </div>
//       </div>

//       {/* Leave Requests Table */}
//       <div style={styles.requestsContainer}>
//         <div style={styles.tableHeader}>
//           <h3 style={styles.sectionHeading}>Leave Requests</h3>
//           <div style={styles.resultsCount}>
//             Showing {filteredRequests.length} of {leaveRequests.length} requests
//           </div>
//         </div>
//         <div style={styles.tableContainer}>
//           <table style={styles.table}>
//             <thead>
//               <tr>
//                 <th style={styles.tableHeader}>Employee</th>
//                 <th style={styles.tableHeader}>Department</th>
//                 <th style={styles.tableHeader}>Leave Type</th>
//                 <th style={styles.tableHeader}>Duration</th>
//                 <th style={styles.tableHeader}>Applied On</th>
//                 <th style={styles.tableHeader}>Status</th>
//                 <th style={styles.tableHeader}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredRequests.map(request => (
//                 <tr key={request.id} style={styles.tableRow}>
//                   <td style={styles.tableCell}>
//                     <div style={styles.employeeInfo}>
//                       <div style={styles.teamMemberName}>{request.teamMemberName}</div>
//                       {/* <div style={styles.employeeId}>{request.employeeId}</div> */}
//                     </div>
//                   </td>
//                   <td style={styles.tableCell}>{request.department}</td>
//                   <td style={styles.tableCell}>{request.type}</td>
//                   <td style={styles.tableCell}>
//                     <div style={styles.durationInfo}>
//                       <div style={styles.dateRange}>
//                         {new Date(request.startDate).toLocaleDateString('en-GB')} to {new Date(request.endDate).toLocaleDateString('en-GB')}
//                       </div>
//                       <div style={styles.daysBadge}>{request.duration}</div>
//                     </div>
//                   </td>
//                   <td style={styles.tableCell}>{request.appliedOn}</td>
//                   <td style={styles.tableCell}>
//                     <span style={{...styles.statusBadge, backgroundColor: getStatusColor(request.status)}}>
//                       {request.status}
//                     </span>
//                   </td>
//                   <td style={styles.tableCell}>
//                     <div style={styles.actionButtons}>
//                       <button 
//                         onClick={() => handleViewDetails(request)}
//                         style={styles.detailsButton}
//                       >
//                         View
//                       </button>
//                       {request.status === 'Pending' && (
//                         <>
//                           <button 
//                             onClick={() => handleApprove(request.id)}
//                             style={styles.approveButton}
//                           >
//                             Approve
//                           </button>
//                           <button 
//                             onClick={() => handleReject(request.id)}
//                             style={styles.rejectButton}
//                           >
//                             Reject
//                           </button>
//                         </>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
          
//           {filteredRequests.length === 0 && (
//             <div style={styles.noResults}>
//               <p>No leave requests match the selected filters.</p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Request Details Modal */}
//       {selectedRequest && (
//         <div style={styles.modalOverlay}>
//           <div style={styles.modal}>
//             <div style={styles.modalHeader}>
//               <h3 style={styles.modalTitle}>Leave Request Details</h3>
//               <button onClick={handleCloseDetails} style={styles.closeButton}>×</button>
//             </div>
            
//             <div style={styles.modalContent}>
//               <div style={styles.detailSection}>
//                 <h4 style={styles.detailHeading}>Employee Information</h4>
//                 <div style={styles.detailGrid}>
//                   <div style={styles.detailItem}>
//                     <span style={styles.detailLabel}>Name:</span>
//                     <span style={styles.detailValue}>{selectedRequest.teamMemberName}</span>
//                   </div>
//                   {/* <div style={styles.detailItem}>
//                     <span style={styles.detailLabel}>ID:</span>
//                     <span style={styles.detailValue}>{selectedRequest.employeeId}</span>
//                   </div> */}
//                   <div style={styles.detailItem}>
//                     <span style={styles.detailLabel}>Department:</span>
//                     <span style={styles.detailValue}>{selectedRequest.department}</span>
//                   </div>
//                   <div style={styles.detailItem}>
//                     <span style={styles.detailLabel}>Emergency Mobile:</span>
//                     <span style={styles.detailValue}>{selectedRequest.emergencyMobileNumber}</span>
//                   </div>
//                   <div style={styles.detailItem}>
//                     <span style={styles.detailLabel}>Email:</span>
//                     <span style={styles.detailValue}>{selectedRequest.email}</span>
//                   </div>
//                   <div style={styles.detailItem}>
//                     <span style={styles.detailLabel}>Contact:</span>
//                     <span style={styles.detailValue}>{selectedRequest.contact}</span>
//                   </div>
//                 </div>
//               </div>
              
//               <div style={styles.detailSection}>
//                 <h4 style={styles.detailHeading}>Leave Information</h4>
//                 <div style={styles.detailGrid}>
//                   <div style={styles.detailItem}>
//                     <span style={styles.detailLabel}>Type:</span>
//                     <span style={styles.detailValue}>{selectedRequest.type}</span>
//                   </div>
//                   <div style={styles.detailItem}>
//                     <span style={styles.detailLabel}>Duration:</span>
//                     <span style={styles.detailValue}>
//                       <div style={styles.durationDetails}>
//                         <div style={styles.dateRangeDetail}>
//                           From: {new Date(selectedRequest.startDate).toLocaleDateString('en-GB', {
//                             day: '2-digit',
//                             month: '2-digit',
//                             year: 'numeric'
//                           })}
//                         </div>
//                         <div style={styles.dateRangeDetail}>
//                           To: {new Date(selectedRequest.endDate).toLocaleDateString('en-GB', {
//                             day: '2-digit',
//                             month: '2-digit',
//                             year: 'numeric'
//                           })}
//                         </div>
//                         <div style={styles.totalDays}>
//                           Total: {selectedRequest.duration}
//                         </div>
//                       </div>
//                     </span>
//                   </div>
//                   <div style={styles.detailItem}>
//                     <span style={styles.detailLabel}>Applied On:</span>
//                     <span style={styles.detailValue}>{selectedRequest.appliedOn}</span>
//                   </div>
//                   <div style={styles.detailItem}>
//                     <span style={styles.detailLabel}>Status:</span>
//                     <span style={styles.detailValue}>
//                       <span style={{...styles.statusBadge, backgroundColor: getStatusColor(selectedRequest.status)}}>
//                         {selectedRequest.status}
//                       </span>
//                     </span>
//                   </div>
//                 </div>
//               </div>
              
//               <div style={styles.detailSection}>
//                 <h4 style={styles.detailHeading}>Reason</h4>
//                 <p style={styles.reasonText}>{selectedRequest.reason}</p>
//               </div>
              
//               {selectedRequest.attachment && (
//                 <div style={styles.detailSection}>
//                   <h4 style={styles.detailHeading}>Attachment</h4>
//                   <div style={styles.attachment}>
//                     <span style={styles.attachmentIcon}>📎</span>
//                     <a href="#" style={styles.attachmentLink}>{selectedRequest.attachment}</a>
//                   </div>
//                 </div>
//               )}
//             </div>
            
//             <div style={styles.modalFooter}>
//               {selectedRequest.status === 'Pending' && (
//                 <>
//                   <button 
//                     onClick={() => handleApprove(selectedRequest.id)}
//                     style={styles.modalApproveButton}
//                   >
//                     Approve Request
//                   </button>
//                   <button 
//                     onClick={() => handleReject(selectedRequest.id)}
//                     style={styles.modalRejectButton}
//                   >
//                     Reject Request
//                   </button>
//                 </>
//               )}
//               <button 
//                 onClick={handleCloseDetails}
//                 style={styles.modalCloseButton}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // Inline CSS styles
// const styles = {
//   container: {
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//     padding: '20px',
//     backgroundColor: '#f5f7f9',
//     minHeight: '100vh'
//   },
//   loading: {
//     padding: '20px',
//     textAlign: 'center',
//     color: '#666',
//     fontSize: '16px',
//     margin: '20px 0'
//   },
//   error: {
//     padding: '15px',
//     backgroundColor: '#ffebee',
//     color: '#c62828',
//     borderRadius: '4px',
//     margin: '15px 0',
//     textAlign: 'center',
//     borderLeft: '4px solid #c62828'
//   },
//   heading: {
//     color: '#2c3e50',
//     marginBottom: '25px',
//     fontSize: '28px',
//     fontWeight: '600',
//     borderBottom: '2px solid #3498db',
//     paddingBottom: '10px'
//   },
//   statsContainer: {
//     display: 'flex',
//     gap: '20px',
//     marginBottom: '30px',
//     flexWrap: 'wrap'
//   },
//   statCard: {
//     flex: '1',
//     minWidth: '180px',
//     backgroundColor: 'white',
//     borderRadius: '10px',
//     padding: '20px',
//     textAlign: 'center',
//     boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
//   },
//   statNumber: {
//     fontSize: '32px',
//     fontWeight: '700',
//     margin: '0 0 10px 0',
//     color: '#2c3e50'
//   },
//   statLabel: {
//     margin: '0',
//     color: '#7f8c8d',
//     fontSize: '14px',
//     fontWeight: '600'
//   },
//   searchContainer: {
//     backgroundColor: 'white',
//     borderRadius: '10px',
//     padding: '20px',
//     marginBottom: '20px',
//     boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
//   },
//   searchBox: {
//     position: 'relative',
//     display: 'flex',
//     alignItems: 'center'
//   },
//   searchIcon: {
//     position: 'absolute',
//     left: '15px',
//     fontSize: '18px',
//     color: '#7f8c8d'
//   },
//   searchInput: {
//     width: '100%',
//     padding: '12px 45px 12px 45px',
//     border: '1px solid #ddd',
//     borderRadius: '30px',
//     fontSize: '16px',
//     outline: 'none',
//     transition: 'border-color 0.3s, box-shadow 0.3s'
//   },
//   clearSearchButton: {
//     position: 'absolute',
//     right: '15px',
//     backgroundColor: 'transparent',
//     border: 'none',
//     fontSize: '20px',
//     cursor: 'pointer',
//     color: '#7f8c8d',
//     padding: '0',
//     width: '24px',
//     height: '24px',
//     borderRadius: '50%',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center'
//   },
//   filtersContainer: {
//     backgroundColor: 'white',
//     borderRadius: '10px',
//     padding: '20px',
//     marginBottom: '30px',
//     boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
//   },
//   filterHeading: {
//     marginTop: '0',
//     marginBottom: '15px',
//     color: '#2c3e50',
//     fontSize: '18px'
//   },
//   filterRow: {
//     display: 'flex',
//     gap: '20px',
//     flexWrap: 'wrap'
//   },
//   filterGroup: {
//     flex: '1',
//     minWidth: '200px'
//   },
//   filterLabel: {
//     display: 'block',
//     marginBottom: '8px',
//     fontWeight: '600',
//     color: '#34495e'
//   },
//   filterSelect: {
//     width: '100%',
//     padding: '10px',
//     border: '1px solid #ddd',
//     borderRadius: '6px',
//     fontSize: '14px'
//   },
//   requestsContainer: {
//     backgroundColor: 'white',
//     borderRadius: '10px',
//     padding: '20px',
//     boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
//   },
//   tableHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '20px'
//   },
//   sectionHeading: {
//     margin: '0',
//     color: '#2c3e50',
//     fontSize: '20px'
//   },
//   resultsCount: {
//     color: '#7f8c8d',
//     fontSize: '14px'
//   },
//   tableContainer: {
//     overflowX: 'auto'
//   },
//   table: {
//     width: '100%',
//     borderCollapse: 'collapse'
//   },
//   tableHeader: {
//     backgroundColor: '#f1f2f6',
//     padding: '12px 15px',
//     textAlign: 'left',
//     fontWeight: '600',
//     color: '#2c3e50',
//     borderBottom: '2px solid #dfe4ea'
//   },
//   tableRow: {
//     borderBottom: '1px solid #dfe4ea'
//   },
//   tableCell: {
//     padding: '12px 15px',
//     verticalAlign: 'top'
//   },
//   employeeInfo: {
//     display: 'flex',
//     flexDirection: 'column'
//   },
//   teamMemberName: {
//     fontWeight: '600',
//     color: '#2c3e50'
//   },
//   employeeId: {
//     fontSize: '12px',
//     color: '#7f8c8d'
//   },
//   durationInfo: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '4px'
//   },
//   dateRange: {
//     fontSize: '14px',
//     color: '#2c3e50'
//   },
//   daysBadge: {
//     backgroundColor: '#e3f2fd',
//     color: '#1976d2',
//     padding: '2px 8px',
//     borderRadius: '12px',
//     fontSize: '12px',
//     fontWeight: '600',
//     display: 'inline-block',
//     alignSelf: 'flex-start'
//   },
//   statusBadge: {
//     display: 'inline-block',
//     padding: '5px 10px',
//     borderRadius: '20px',
//     fontSize: '12px',
//     fontWeight: '600',
//     color: 'white'
//   },
//   actionButtons: {
//     display: 'flex',
//     gap: '8px',
//     flexWrap: 'wrap'
//   },
//   detailsButton: {
//     padding: '6px 12px',
//     backgroundColor: '#3498db',
//     color: 'white',
//     border: 'none',
//     borderRadius: '4px',
//     fontSize: '12px',
//     cursor: 'pointer',
//     fontWeight: '600'
//   },
//   approveButton: {
//     padding: '6px 12px',
//     backgroundColor: '#2ecc71',
//     color: 'white',
//     border: 'none',
//     borderRadius: '4px',
//     fontSize: '12px',
//     cursor: 'pointer',
//     fontWeight: '600'
//   },
//   rejectButton: {
//     padding: '6px 12px',
//     backgroundColor: '#e74c3c',
//     color: 'white',
//     border: 'none',
//     borderRadius: '4px',
//     fontSize: '12px',
//     cursor: 'pointer',
//     fontWeight: '600'
//   },
//   noResults: {
//     textAlign: 'center',
//     padding: '40px',
//     color: '#7f8c8d'
//   },
//   modalOverlay: {
//     position: 'fixed',
//     top: '0',
//     left: '0',
//     right: '0',
//     bottom: '0',
//     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: '1000',
//     padding: '20px'
//   },
//   modal: {
//     backgroundColor: 'white',
//     borderRadius: '10px',
//     width: '100%',
//     maxWidth: '700px',
//     maxHeight: '90vh',
//     overflowY: 'auto',
//     boxShadow: '0 5px 15px rgba(0,0,0,0.3)'
//   },
//   modalHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '20px',
//     borderBottom: '1px solid #dfe4ea'
//   },
//   modalTitle: {
//     margin: '0',
//     color: '#2c3e50'
//   },
//   closeButton: {
//     backgroundColor: 'transparent',
//     border: 'none',
//     fontSize: '24px',
//     cursor: 'pointer',
//     color: '#7f8c8d'
//   },
//   modalContent: {
//     padding: '20px'
//   },
//   detailSection: {
//     marginBottom: '25px'
//   },
//   detailHeading: {
//     margin: '0 0 15px 0',
//     color: '#2c3e50',
//     fontSize: '16px'
//   },
//   detailGrid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
//     gap: '15px'
//   },
//   detailItem: {
//     display: 'flex',
//     flexDirection: 'column'
//   },
//   detailLabel: {
//     fontSize: '12px',
//     color: '#7f8c8d',
//     fontWeight: '600',
//     marginBottom: '5px'
//   },
//   detailValue: {
//     fontSize: '14px',
//     color: '#2c3e50'
//   },
//   reasonText: {
//     margin: '0',
//     padding: '15px',
//     backgroundColor: '#f9f9f9',
//     borderRadius: '6px',
//     borderLeft: '4px solid #3498db'
//   },
//   attachment: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px'
//   },
//   attachmentIcon: {
//     fontSize: '18px'
//   },
//   attachmentLink: {
//     color: '#3498db',
//     textDecoration: 'none',
//     fontWeight: '600'
//   },
//   daysText: {
//     color: '#7f8c8d',
//     fontSize: '12px',
//     marginLeft: '5px'
//   },
//   durationDetails: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '4px'
//   },
//   dateRangeDetail: {
//     fontSize: '14px',
//     color: '#2c3e50'
//   },
//   totalDays: {
//     fontSize: '14px',
//     fontWeight: '600',
//     color: '#1976d2',
//     backgroundColor: '#e3f2fd',
//     padding: '2px 8px',
//     borderRadius: '12px',
//     display: 'inline-block',
//     marginTop: '4px'
//   },
//   modalFooter: {
//     display: 'flex',
//     justifyContent: 'flex-end',
//     gap: '10px',
//     padding: '20px',
//     borderTop: '1px solid #dfe4ea'
//   },
//   modalApproveButton: {
//     padding: '10px 20px',
//     backgroundColor: '#2ecc71',
//     color: 'white',
//     border: 'none',
//     borderRadius: '6px',
//     fontSize: '14px',
//     cursor: 'pointer',
//     fontWeight: '600'
//   },
//   modalRejectButton: {
//     padding: '10px 20px',
//     backgroundColor: '#e74c3c',
//     color: 'white',
//     border: 'none',
//     borderRadius: '6px',
//     fontSize: '14px',
//     cursor: 'pointer',
//     fontWeight: '600'
//   },
//   modalCloseButton: {
//     padding: '10px 20px',
//     backgroundColor: '#95a5a6',
//     color: 'white',
//     border: 'none',
//     borderRadius: '6px',
//     fontSize: '14px',
//     cursor: 'pointer',
//     fontWeight: '600'
//   }
// };

// // Add hover effects
// Object.assign(styles.searchInput, {
//   ':focus': {
//     borderColor: '#3498db',
//     boxShadow: '0 0 0 3px rgba(52, 152, 219, 0.2)'
//   }
// });

// Object.assign(styles.clearSearchButton, {
//   ':hover': {
//     backgroundColor: '#f1f2f6'
//   }
// });

// export default LeaveApproval;




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";

const LeaveApproval = () => {
  // State for leave requests
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // State for filters
  const [filters, setFilters] = useState({
    status: 'All',
    department: 'All'
  });

  // State for search query
  const [searchQuery, setSearchQuery] = useState('');
  
  // State for departments
  const [departments, setDepartments] = useState(['All']);

  // State for selected request
  const [selectedRequest, setSelectedRequest] = useState(null);

  // Handle filter changes
  const handleFilterChange = (filterType, value) => {
    setFilters({
      ...filters,
      [filterType]: value
    });
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Fetch leave requests from API
  const fetchLeaveRequests = async () => {
    setLoading(true);
    setError(null);

    const token = localStorage.getItem("authToken") || localStorage.getItem("token");
    if (!token) {
      setError("No access token found. Please log in.");
      setLoading(false);
      return;
    }

    let decoded;
    try {
      decoded = jwtDecode(token);
    } catch (err) {
      console.error("Invalid token:", err);
      setError("Invalid token. Please log in again.");
      setLoading(false);
      return;
    }

    // Extract companyId from token payload
    const companyId = decoded.companyId || decoded.id;
    if (!companyId) {
      setError("No companyId found in token.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get("https://customersupport-jhy9.onrender.com/api/leaves", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          company: companyId,
        },
      });

      console.log("Leave requests API response:", response.data);

      let leaves = [];
      if (response.data && Array.isArray(response.data)) {
        leaves = response.data;
      } else if (response.data.leaves && Array.isArray(response.data.leaves)) {
        leaves = response.data.leaves;
      }

      const formattedRequests = await Promise.all(
        leaves.map(async (leave) => {
          const fromDate = new Date(leave.fromDate);
          const toDate = new Date(leave.toDate);
          const timeDiff = toDate.getTime() - fromDate.getTime();
          const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + 1;

          const appliedDate = leave.appliedDate || leave.createdAt;
          const formattedAppliedDate = appliedDate
            ? new Date(appliedDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
            : "N/A";

          let employeeDetails = null;

          if (leave.employee && (leave.employee._id || leave.employee)) {
            const employeeId = leave.employee._id || leave.employee;
            try {
              const employeeResponse = await axios.get(
                `https://customersupport-jhy9.onrender.com/api/employees/${employeeId}`,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
              employeeDetails = employeeResponse.data;
              console.log(`Employee details for ${employeeId}:`, employeeDetails);

              if (
                employeeDetails?.department &&
                typeof employeeDetails.department === "string"
              ) {
                try {
                  const deptResponse = await axios.get(
                    `https://customersupport-jhy9.onrender.com/api/departments/${employeeDetails.department}`,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );
                  employeeDetails.departmentDetails = deptResponse.data;
                  console.log(
                    `Department details for ${employeeDetails.department}:`,
                    deptResponse.data
                  );
                } catch (deptErr) {
                  console.error(
                    `Error fetching department ${employeeDetails.department}:`,
                    deptErr
                  );
                }
              }
            } catch (employeeErr) {
              console.error(`Error fetching employee ${employeeId}:`, employeeErr);
            }
          }

          return {
            id: leave._id,
            teamMemberName:
              employeeDetails?.teamMemberName ||
              employeeDetails?.name ||
              leave.employee?.teamMemberName ||
              leave.employee?.name ||
              (employeeDetails?.firstName && employeeDetails?.lastName
                ? `${employeeDetails.firstName} ${employeeDetails.lastName}`
                : leave.employee?.firstName && leave.employee?.lastName
                ? `${leave.employee.firstName} ${leave.employee.lastName}`
                : "Unknown Employee"),
            employeeId:
              employeeDetails?._id || leave.employee?._id || "N/A",
            department:
              employeeDetails?.departmentDetails?.name ||
              employeeDetails?.departmentDetails?.departmentName ||
              employeeDetails?.department?.name ||
              (typeof employeeDetails?.department === "string"
                ? "Loading..."
                : employeeDetails?.department) ||
              leave.employee?.department?.name ||
              leave.employee?.department ||
              "N/A",
            type: leave.leaveType || "Leave",
            startDate: leave.fromDate,
            endDate: leave.toDate,
            days: daysDiff > 0 ? daysDiff : 1,
            duration: `${daysDiff > 0 ? daysDiff : 1} day${
              daysDiff > 1 ? "s" : ""
            }`,
            status: leave.status || "pending",
            reason: leave.reason || "No reason provided",
            appliedOn: formattedAppliedDate,
            attachment: leave.attachment || null,
            contact:
              employeeDetails?.emergencyMobileNumber ||
              employeeDetails?.phone ||
              employeeDetails?.contact ||
              leave.employee?.phone ||
              leave.employee?.emergencyMobileNumber ||
              leave.employee?.contact ||
              "N/A",
            emergencyMobileNumber:
              employeeDetails?.emergencyMobileNumber ||
              leave.employee?.emergencyMobileNumber ||
              "N/A",
            email:
              employeeDetails?.email ||
              leave.employee?.email ||
              "N/A",
            fullEmployeeDetails: employeeDetails,
          };
        })
      );

      setLeaveRequests(formattedRequests);
      console.log("Formatted leave requests:", formattedRequests);
    } catch (err) {
      console.error("Error fetching leave requests:", err);
      setError("Failed to load leave requests. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch leave requests on component mount
  useEffect(() => {
    fetchLeaveRequests();
  }, []);

  // Handle approval action
  const handleApprove = async (id) => {
    try {
      const token = localStorage.getItem('authToken') || localStorage.getItem('token');
      
      if (!token) {
        setError('Authentication token not found. Please login again.');
        return;
      }

      console.log('🎯 APPROVING LEAVE REQUEST:', {
        leaveRequestId: id,
        timestamp: new Date().toISOString()
      });
      
      // Decode JWT token to get approver details
      let approverId, approverRole, approverName, companyId;
      try {
        const decoded = jwtDecode(token);
        console.log('🔍 APPROVER TOKEN DECODING:', {
          fullToken: decoded,
          id: decoded.id,
          role: decoded.role,
          name: decoded.name || decoded.username,
          companyId: decoded.companyId
        });
        
        approverId = decoded.id || decoded._id || decoded.userId;
        approverRole = decoded.role || 'Admin';
        approverName = decoded.name || decoded.username || decoded.teamMemberName || 'Admin';
        companyId = decoded.companyId || decoded.company?._id || decoded.orgId;
        
        console.log('├── Approver ID:', approverId);
        console.log('├── Approver Role:', approverRole);
        console.log('├── Approver Name:', approverName);
        console.log('└── Company ID:', companyId);
      } catch (decodeError) {
        console.error('❌ Error decoding token:', decodeError);
        setError('Invalid authentication token. Please login again.');
        localStorage.removeItem('authToken');
        return;
      }

      // Comprehensive approval data structure
      const approvalData = {
        status: 'Approved',
        approvedBy: approverId,
        approvedAt: new Date().toISOString(),
        approverRole: approverRole,
        approverName: approverName,
        companyId: companyId,
        approvalHistory: {
          action: 'approved',
          actionBy: approverId,
          actionByName: approverName,
          actionByRole: approverRole,
          actionAt: new Date().toISOString(),
          comments: `Leave request approved by ${approverName} (${approverRole})`
        }
      };

      console.log('📤 SENDING APPROVAL DATA:', approvalData);
      
      const response = await axios.put(
        `https://customersupport-jhy9.onrender.com/api/leaves/${id}/status`,
        approvalData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          validateStatus: (status) => status < 500
        }
      );
      
      console.log('✅ SUCCESS RESPONSE:', {
        status: response.status,
        statusText: response.statusText,
        data: response.data
      });

      if (response.status === 401) {
        console.error('🚫 Session expired during approval');
        localStorage.removeItem('authToken');
        setError('Session expired. Please login again.');
        window.location.href = '/login';
        return;
      }
      
      // Update local state with comprehensive approval information
      setLeaveRequests(prevRequests => 
        prevRequests.map(request => 
          request.id === id ? { 
            ...request, 
            status: 'Approved',
            approvedBy: approverName,
            approvedAt: new Date().toISOString(),
            approverRole: approverRole
          } : request
        )
      );
      
      // Show success message with approver details
      setError('');
      alert(`Leave request approved successfully by ${approverName} (${approverRole})!`);
      
    } catch (err) {
      console.error('❌ ERROR APPROVING LEAVE:', {
        error: err.message,
        status: err.response?.status,
        statusText: err.response?.statusText,
        data: err.response?.data,
        fullError: err
      });
      
      if (err.response?.status === 401) {
        console.error('🚫 Authentication failed - cleaning up token');
        localStorage.removeItem('authToken');
        setError('Session expired. Please login again.');
        window.location.href = '/login';
      } else {
        setError('Failed to approve leave. Please try again.');
        alert(`Failed to approve leave request: ${err.response?.data?.message || err.message}`);
      }
    }
  };

  // Handle rejection action
  const handleReject = async (id) => {
    // Prompt for rejection reason
    const rejectionReason = prompt('Please provide a reason for rejecting this leave request:');
    
    if (!rejectionReason || rejectionReason.trim() === '') {
      alert('Rejection reason is required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken') || localStorage.getItem('token');
      
      if (!token) {
        setError('Authentication token not found. Please login again.');
        return;
      }

      console.log('🎯 REJECTING LEAVE REQUEST:', {
        leaveRequestId: id,
        rejectionReason: rejectionReason,
        timestamp: new Date().toISOString()
      });
      
      // Decode JWT token to get rejector details
      let rejectorId, rejectorRole, rejectorName, companyId;
      try {
        const decoded = jwtDecode(token);
        console.log('🔍 REJECTOR TOKEN DECODING:', {
          fullToken: decoded,
          id: decoded.id,
          role: decoded.role,
          name: decoded.name || decoded.username,
          companyId: decoded.companyId
        });
        
        rejectorId = decoded.id || decoded._id || decoded.userId;
        rejectorRole = decoded.role || 'Admin';
        rejectorName = decoded.name || decoded.username || decoded.teamMemberName || 'Admin';
        companyId = decoded.companyId || decoded.company?._id || decoded.orgId;
        
        console.log('├── Rejector ID:', rejectorId);
        console.log('├── Rejector Role:', rejectorRole);
        console.log('├── Rejector Name:', rejectorName);
        console.log('├── Rejection Reason:', rejectionReason);
        console.log('└── Company ID:', companyId);
      } catch (decodeError) {
        console.error('❌ Error decoding token:', decodeError);
        setError('Invalid authentication token. Please login again.');
        localStorage.removeItem('authToken');
        return;
      }

      // Comprehensive rejection data structure
      const rejectionData = {
        status: 'Rejected',
        rejectedBy: rejectorId,
        rejectedAt: new Date().toISOString(),
        rejectorRole: rejectorRole,
        rejectorName: rejectorName,
        rejectionReason: rejectionReason.trim(),
        companyId: companyId,
        approvalHistory: {
          action: 'rejected',
          actionBy: rejectorId,
          actionByName: rejectorName,
          actionByRole: rejectorRole,
          actionAt: new Date().toISOString(),
          comments: rejectionReason.trim()
        }
      };

      console.log('📤 SENDING REJECTION DATA:', rejectionData);
      
      const response = await axios.put(
        `https://customersupport-jhy9.onrender.com/api/leaves/${id}/status`,
        rejectionData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          validateStatus: (status) => status < 500
        }
      );
      
      console.log('✅ SUCCESS RESPONSE:', {
        status: response.status,
        statusText: response.statusText,
        data: response.data
      });

      if (response.status === 401) {
        console.error('🚫 Session expired during rejection');
        localStorage.removeItem('authToken');
        setError('Session expired. Please login again.');
        window.location.href = '/login';
        return;
      }
      
      // Update local state with comprehensive rejection information
      setLeaveRequests(prevRequests => 
        prevRequests.map(request => 
          request.id === id ? { 
            ...request, 
            status: 'Rejected',
            rejectedBy: rejectorName,
            rejectedAt: new Date().toISOString(),
            rejectorRole: rejectorRole,
            rejectionReason: rejectionReason.trim()
          } : request
        )
      );
      
      // Show success message with rejector details
      setError('');
      alert(`Leave request rejected successfully by ${rejectorName} (${rejectorRole})!`);
      
    } catch (err) {
      console.error('❌ ERROR REJECTING LEAVE:', {
        error: err.message,
        status: err.response?.status,
        statusText: err.response?.statusText,
        data: err.response?.data,
        fullError: err
      });
      
      if (err.response?.status === 401) {
        console.error('🚫 Authentication failed - cleaning up token');
        localStorage.removeItem('authToken');
        setError('Session expired. Please login again.');
        window.location.href = '/login';
      } else {
        setError('Failed to reject leave. Please try again.');
        alert(`Failed to reject leave request: ${err.response?.data?.message || err.message}`);
      }
    }
  };

  // Handle view details
  const handleViewDetails = (request) => {
    setSelectedRequest(request);
  };

  // Close details view
  const handleCloseDetails = () => {
    setSelectedRequest(null);
  };

  // Filter and search leave requests
  const filteredRequests = leaveRequests.filter(request => {
    // Apply filters
    const statusMatch = filters.status === 'All' || request.status === filters.status;
    const departmentMatch = filters.department === 'All' || request.department === filters.department;
    
    // Apply search query
    const searchMatch = searchQuery === '' || 
      request.teamMemberName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      request.employeeId.toLowerCase().includes(searchQuery.toLowerCase()) ||
      request.department.toLowerCase().includes(searchQuery.toLowerCase()) ||
      request.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
      request.reason.toLowerCase().includes(searchQuery.toLowerCase());
    
    return statusMatch && departmentMatch && searchMatch;
  });

  // Count requests by status (case insensitive)
  const pendingCount = leaveRequests.filter(req => 
    req.status && req.status.toLowerCase() === 'pending'
  ).length;
  const approvedCount = leaveRequests.filter(req => 
    req.status && req.status.toLowerCase() === 'approved'
  ).length;
  const rejectedCount = leaveRequests.filter(req => 
    req.status && req.status.toLowerCase() === 'rejected'
  ).length;

  // Get status badge color
  const getStatusColor = (status) => {
    switch(status?.toLowerCase()) {
      case 'approved': return '#28C76F';
      case 'pending': return '#FF9F43';
      case 'rejected': return '#EA5455';
      default: return '#775DD0';
    }
  };

  // Fetch departments for the selected company
  useEffect(() => {
    const fetchDepartments = async () => {
      const token = localStorage.getItem("authToken") || localStorage.getItem("token");

      if (!token) {
        console.error("No access token found. Please log in.");
        return;
      }

      let companyId;
      try {
        const decoded = jwtDecode(token);
        companyId = decoded.companyId || decoded.id; 
      } catch (err) {
        console.error("Error decoding token:", err);
        return;
      }

      if (!companyId) {
        console.error("No companyId found in token.");
        return;
      }

      try {
        const response = await axios.get(
          `https://customersupport-jhy9.onrender.com/api/departments/company/${companyId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data && Array.isArray(response.data)) {
          // Extract department names from the response
          const departmentNames = response.data.map(
            (dept) => dept.name || dept.departmentName
          );
          setDepartments(["All", ...new Set(departmentNames)]);
        } else {
          // Fallback to unique departments from leave requests
          const uniqueDepts = [
            "All",
            ...new Set(leaveRequests.map((req) => req.department)),
          ];
          setDepartments(
            uniqueDepts.filter((dept) => dept !== null && dept !== undefined)
          );
        }
      } catch (error) {
        console.error("Error fetching departments:", error);
        // Fallback to unique departments from leave requests if API call fails
        const uniqueDepts = [
          "All",
          ...new Set(leaveRequests.map((req) => req.department)),
        ];
        setDepartments(
          uniqueDepts.filter((dept) => dept !== null && dept !== undefined)
        );
      }
    };

    fetchDepartments();
  }, [leaveRequests]);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.pageTitle}>Leave Approval Dashboard</h1>
        <p style={styles.pageSubtitle}>Manage and review employee leave requests efficiently</p>
      </div>
      
      {/* Loading and Error States */}
      {loading && (
        <div style={styles.loadingCard}>
          <div style={styles.loadingSpinner}></div>
          <p style={styles.loadingText}>Loading leave requests...</p>
        </div>
      )}
      
      {error && (
        <div style={styles.errorCard}>
          <div style={styles.errorIcon}>⚠️</div>
          <p style={styles.errorText}>{error}</p>
        </div>
      )}
      
      {/* Stats Overview */}
      <div style={styles.statsGrid}>
        <div style={{...styles.statCard, ...styles.pendingCard}}>
          <div style={styles.statIcon}>⏳</div>
          <div style={styles.statContent}>
            <h3 style={styles.statNumber}>{pendingCount}</h3>
            <p style={styles.statLabel}>Pending Requests</p>
          </div>
        </div>
        <div style={{...styles.statCard, ...styles.approvedCard}}>
          <div style={styles.statIcon}>✅</div>
          <div style={styles.statContent}>
            <h3 style={styles.statNumber}>{approvedCount}</h3>
            <p style={styles.statLabel}>Approved</p>
          </div>
        </div>
        <div style={{...styles.statCard, ...styles.rejectedCard}}>
          <div style={styles.statIcon}>❌</div>
          <div style={styles.statContent}>
            <h3 style={styles.statNumber}>{rejectedCount}</h3>
            <p style={styles.statLabel}>Rejected</p>
          </div>
        </div>
        <div style={{...styles.statCard, ...styles.totalCard}}>
          <div style={styles.statIcon}>📊</div>
          <div style={styles.statContent}>
            <h3 style={styles.statNumber}>{leaveRequests.length}</h3>
            <p style={styles.statLabel}>Total Requests</p>
          </div>
        </div>
      </div>

      {/* Search and Filters Card */}
      <div style={styles.controlsCard}>
        {/* Search Box */}
        <div style={styles.searchSection}>
          <div style={styles.searchBox}>
            <div style={styles.searchIcon}>🔍</div>
            <input
              type="text"
              placeholder="Search by employee name, department, leave type or reason..."
              value={searchQuery}
              onChange={handleSearchChange}
              style={styles.searchInput}
            />
            {searchQuery && (
              <button 
                onClick={() => setSearchQuery('')}
                style={styles.clearButton}
              >
                ✕
              </button>
            )}
          </div>
        </div>

        {/* Filters */}
        <div style={styles.filtersSection}>
          <div style={styles.filterGroup}>
            <label style={styles.filterLabel}>Status</label>
            <div style={styles.selectWrapper}>
              <select 
                value={filters.status} 
                onChange={(e) => handleFilterChange('status', e.target.value)}
                style={styles.filterSelect}
              >
                <option value="All">All Statuses</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>
            </div>
          </div>
          
          <div style={styles.filterGroup}>
            <label style={styles.filterLabel}>Department</label>
            <div style={styles.selectWrapper}>
              <select 
                value={filters.department} 
                onChange={(e) => handleFilterChange('department', e.target.value)}
                style={styles.filterSelect}
              >
                {departments.map(dept => (
                  <option key={dept} value={dept}>{dept}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Results Count */}
      <div style={styles.resultsHeader}>
        <h3 style={styles.resultsTitle}>Leave Requests</h3>
        <div style={styles.resultsCount}>
          Showing <span style={styles.countNumber}>{filteredRequests.length}</span> of <span style={styles.countNumber}>{leaveRequests.length}</span> requests
        </div>
      </div>

      {/* Leave Requests Table */}
      <div style={styles.tableCard}>
        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.tableHeader}>Employee</th>
                <th style={styles.tableHeader}>Department</th>
                <th style={styles.tableHeader}>Leave Type</th>
                <th style={styles.tableHeader}>Duration</th>
                <th style={styles.tableHeader}>Applied On</th>
                <th style={styles.tableHeader}>Status</th>
                <th style={styles.tableHeader}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRequests.map(request => (
                <tr key={request.id} style={styles.tableRow}>
                  <td style={styles.tableCell}>
                    <div style={styles.employeeInfo}>
                      <div style={styles.employeeName}>{request.teamMemberName}</div>
                    </div>
                  </td>
                  <td style={styles.tableCell}>
                    <div style={styles.departmentTag}>{request.department}</div>
                  </td>
                  <td style={styles.tableCell}>
                    <div style={styles.leaveType}>{request.type}</div>
                  </td>
                  <td style={styles.tableCell}>
                    <div style={styles.durationInfo}>
                      <div style={styles.dateRange}>
                        {new Date(request.startDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })} - {new Date(request.endDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })}
                      </div>
                      <div style={styles.daysBadge}>{request.duration}</div>
                    </div>
                  </td>
                  <td style={styles.tableCell}>
                    <div style={styles.appliedDate}>{request.appliedOn}</div>
                  </td>
                  <td style={styles.tableCell}>
                    <span style={{
                      ...styles.statusBadge, 
                      backgroundColor: getStatusColor(request.status),
                      color: '#FFFFFF'
                    }}>
                      {request.status}
                    </span>
                  </td>
                  <td style={styles.tableCell}>
                    <div style={styles.actionButtons}>
                      <button 
                        onClick={() => handleViewDetails(request)}
                        style={styles.viewButton}
                      >
                        👁️ View
                      </button>
                      {request.status === 'Pending' && (
                        <>
                          <button 
                            onClick={() => handleApprove(request.id)}
                            style={styles.approveButton}
                          >
                            ✓ Approve
                          </button>
                          <button 
                            onClick={() => handleReject(request.id)}
                            style={styles.rejectButton}
                          >
                            ✗ Reject
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          {filteredRequests.length === 0 && !loading && (
            <div style={styles.emptyState}>
              <div style={styles.emptyIcon}>📋</div>
              <h3 style={styles.emptyTitle}>No Leave Requests Found</h3>
              <p style={styles.emptyText}>No leave requests match the selected filters. Try adjusting your search criteria.</p>
            </div>
          )}
        </div>
      </div>

      {/* Request Details Modal */}
      {selectedRequest && (
        <div style={styles.modalOverlay} onClick={handleCloseDetails}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>Leave Request Details</h3>
              <button onClick={handleCloseDetails} style={styles.closeButton}>✕</button>
            </div>
            
            <div style={styles.modalContent}>
              <div style={styles.modalSection}>
                <h4 style={styles.sectionTitle}>👤 Employee Information</h4>
                <div style={styles.infoGrid}>
                  <div style={styles.infoItem}>
                    <span style={styles.infoLabel}>Name</span>
                    <span style={styles.infoValue}>{selectedRequest.teamMemberName}</span>
                  </div>
                  <div style={styles.infoItem}>
                    <span style={styles.infoLabel}>Department</span>
                    <span style={styles.infoValue}>{selectedRequest.department}</span>
                  </div>
                  <div style={styles.infoItem}>
                    <span style={styles.infoLabel}>Email</span>
                    <span style={styles.infoValue}>{selectedRequest.email}</span>
                  </div>
                  <div style={styles.infoItem}>
                    <span style={styles.infoLabel}>Emergency Contact</span>
                    <span style={styles.infoValue}>{selectedRequest.emergencyMobileNumber}</span>
                  </div>
                </div>
              </div>
              
              <div style={styles.modalSection}>
                <h4 style={styles.sectionTitle}>🏖️ Leave Information</h4>
                <div style={styles.infoGrid}>
                  <div style={styles.infoItem}>
                    <span style={styles.infoLabel}>Leave Type</span>
                    <span style={styles.infoValue}>{selectedRequest.type}</span>
                  </div>
                  <div style={styles.infoItem}>
                    <span style={styles.infoLabel}>Start Date</span>
                    <span style={styles.infoValue}>
                      {new Date(selectedRequest.startDate).toLocaleDateString('en-GB', {
                        weekday: 'long',
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric'
                      })}
                    </span>
                  </div>
                  <div style={styles.infoItem}>
                    <span style={styles.infoLabel}>End Date</span>
                    <span style={styles.infoValue}>
                      {new Date(selectedRequest.endDate).toLocaleDateString('en-GB', {
                        weekday: 'long',
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric'
                      })}
                    </span>
                  </div>
                  <div style={styles.infoItem}>
                    <span style={styles.infoLabel}>Duration</span>
                    <span style={{...styles.infoValue, ...styles.durationHighlight}}>
                      {selectedRequest.duration}
                    </span>
                  </div>
                  <div style={styles.infoItem}>
                    <span style={styles.infoLabel}>Applied On</span>
                    <span style={styles.infoValue}>{selectedRequest.appliedOn}</span>
                  </div>
                  <div style={styles.infoItem}>
                    <span style={styles.infoLabel}>Status</span>
                    <span style={{
                      ...styles.statusBadge, 
                      backgroundColor: getStatusColor(selectedRequest.status)
                    }}>
                      {selectedRequest.status}
                    </span>
                  </div>
                </div>
              </div>
              
              <div style={styles.modalSection}>
                <h4 style={styles.sectionTitle}>📝 Reason</h4>
                <div style={styles.reasonBox}>
                  {selectedRequest.reason}
                </div>
              </div>
              
              {selectedRequest.attachment && (
                <div style={styles.modalSection}>
                  <h4 style={styles.sectionTitle}>📎 Attachment</h4>
                  <div style={styles.attachmentBox}>
                    <span style={styles.attachmentIcon}>📄</span>
                    <a href="#" style={styles.attachmentLink}>{selectedRequest.attachment}</a>
                  </div>
                </div>
              )}
            </div>
            
            <div style={styles.modalFooter}>
              {selectedRequest.status === 'Pending' && (
                <>
                  <button 
                    onClick={() => {
                      handleApprove(selectedRequest.id);
                      handleCloseDetails();
                    }}
                    style={styles.modalApproveBtn}
                  >
                    ✓ Approve Request
                  </button>
                  <button 
                    onClick={() => {
                      handleReject(selectedRequest.id);
                      handleCloseDetails();
                    }}
                    style={styles.modalRejectBtn}
                  >
                    ✗ Reject Request
                  </button>
                </>
              )}
              <button 
                onClick={handleCloseDetails}
                style={styles.modalCloseBtn}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Modern CSS-in-JS styles with the requested color scheme
const styles = {
  container: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    padding: '24px',
    backgroundColor: '#F8F9FA',
    minHeight: '100vh',
    lineHeight: '1.5',
  },
  
  header: {
    marginBottom: '32px',
  },
  
  pageTitle: {
    fontSize: '32px',
    fontWeight: '700',
    color: '#2C2C2C',
    margin: '0 0 8px 0',
    letterSpacing: '-0.02em',
  },
  
  pageSubtitle: {
    fontSize: '16px',
    color: '#6E6E6E',
    margin: '0',
    fontWeight: '400',
  },
  
  loadingCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '48px',
    textAlign: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
    border: '1px solid #F5F6FA',
    marginBottom: '24px',
  },
  
  loadingSpinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #F5F6FA',
    borderTop: '4px solid #7367F0',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 16px auto',
  },
  
  loadingText: {
    color: '#6E6E6E',
    fontSize: '16px',
    margin: '0',
  },
  
  errorCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '24px',
    marginBottom: '24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
    border: '1px solid #FF4560',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  
  errorIcon: {
    fontSize: '24px',
  },
  
  errorText: {
    color: '#FF4560',
    fontSize: '16px',
    fontWeight: '500',
    margin: '0',
  },
  
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '20px',
    marginBottom: '32px',
  },
  
  statCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
    border: '1px solid #F5F6FA',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    cursor: 'pointer',
  },
  
  statIcon: {
    fontSize: '32px',
    width: '56px',
    height: '56px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  statContent: {
    flex: '1',
  },
  
  statNumber: {
    fontSize: '28px',
    fontWeight: '700',
    margin: '0 0 4px 0',
    color: '#2C2C2C',
  },
  
  statLabel: {
    fontSize: '14px',
    color: '#6E6E6E',
    margin: '0',
    fontWeight: '500',
  },
  
  pendingCard: {
    borderLeft: '4px solid #FF9F43',
  },
  
  approvedCard: {
    borderLeft: '4px solid #28C76F',
  },
  
  rejectedCard: {
    borderLeft: '4px solid #EA5455',
  },
  
  totalCard: {
    borderLeft: '4px solid #7367F0',
  },
  
  controlsCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '24px',
    marginBottom: '24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
    border: '1px solid #F5F6FA',
  },
  
  searchSection: {
    marginBottom: '24px',
  },
  
  searchBox: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  
  searchIcon: {
    position: 'absolute',
    left: '16px',
    fontSize: '18px',
    color: '#6E6E6E',
    zIndex: 1,
  },
  
  searchInput: {
    width: '100%',
    padding: '16px 50px',
    border: '2px solid #F5F6FA',
    borderRadius: '12px',
    fontSize: '16px',
    outline: 'none',
    transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
    backgroundColor: '#F8F9FA',
  },
  
  clearButton: {
    position: 'absolute',
    right: '16px',
    backgroundColor: '#F5F6FA',
    border: 'none',
    borderRadius: '8px',
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    color: '#6E6E6E',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease',
  },
  
  filtersSection: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
  },
  
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  
  filterLabel: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333333',
  },
  
  selectWrapper: {
    position: 'relative',
  },
  
  filterSelect: {
    width: '100%',
    padding: '12px 16px',
    border: '2px solid #F5F6FA',
    borderRadius: '12px',
    fontSize: '16px',
    outline: 'none',
    backgroundColor: '#F8F9FA',
    cursor: 'pointer',
    transition: 'border-color 0.3s ease',
  },
  
  resultsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  
  resultsTitle: {
    fontSize: '22px',
    fontWeight: '700',
    color: '#2C2C2C',
    margin: '0',
  },
  
  resultsCount: {
    fontSize: '14px',
    color: '#6E6E6E',
    fontWeight: '500',
  },
  
  countNumber: {
    fontWeight: '700',
    color: '#7367F0',
  },
  
  tableCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '0',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
    border: '1px solid #F5F6FA',
    overflow: 'hidden',
  },
  
  tableWrapper: {
    overflowX: 'auto',
  },
  
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  
  tableHeader: {
    backgroundColor: '#F8F9FA',
    padding: '16px 20px',
    textAlign: 'left',
    fontWeight: '600',
    color: '#333333',
    fontSize: '14px',
    borderBottom: '1px solid #F5F6FA',
    whiteSpace: 'nowrap',
  },
  
  tableRow: {
    borderBottom: '1px solid #F5F6FA',
    transition: 'background-color 0.2s ease',
  },
  
  tableCell: {
    padding: '16px 20px',
    verticalAlign: 'middle',
  },
  
  employeeInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  
  employeeName: {
    fontWeight: '600',
    color: '#2C2C2C',
    fontSize: '15px',
  },
  
  departmentTag: {
    backgroundColor: '#7367F0',
    color: '#FFFFFF',
    padding: '6px 12px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '500',
    display: 'inline-block',
  },
  
  leaveType: {
    color: '#333333',
    fontWeight: '500',
    fontSize: '14px',
  },
  
  durationInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  
  dateRange: {
    fontSize: '14px',
    color: '#6E6E6E',
    fontWeight: '500',
  },
  
  daysBadge: {
    backgroundColor: '#008FFB',
    color: '#FFFFFF',
    padding: '4px 8px',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: '600',
    display: 'inline-block',
    alignSelf: 'flex-start',
  },
  
  appliedDate: {
    color: '#6E6E6E',
    fontSize: '14px',
    fontWeight: '500',
  },
  
  statusBadge: {
    display: 'inline-block',
    padding: '6px 12px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    textAlign: 'center',
    minWidth: '70px',
  },
  
  actionButtons: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  
  viewButton: {
    padding: '8px 12px',
    backgroundColor: '#7367F0',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'background-color 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  
  approveButton: {
    padding: '8px 12px',
    backgroundColor: '#28C76F',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'background-color 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  
  rejectButton: {
    padding: '8px 12px',
    backgroundColor: '#EA5455',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'background-color 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  
  emptyState: {
    textAlign: 'center',
    padding: '64px 24px',
  },
  
  emptyIcon: {
    fontSize: '64px',
    marginBottom: '16px',
    opacity: '0.5',
  },
  
  emptyTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#333333',
    margin: '0 0 8px 0',
  },
  
  emptyText: {
    fontSize: '16px',
    color: '#6E6E6E',
    margin: '0',
  },
  
  // Modal styles
  modalOverlay: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: 'rgba(44, 44, 44, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '1000',
    padding: '24px',
  },
  
  modal: {
    backgroundColor: '#FFFFFF',
    borderRadius: '20px',
    width: '100%',
    maxWidth: '800px',
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
    border: '1px solid #F5F6FA',
  },
  
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '24px 32px',
    borderBottom: '1px solid #F5F6FA',
    backgroundColor: '#F8F9FA',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
  },
  
  modalTitle: {
    margin: '0',
    fontSize: '24px',
    fontWeight: '700',
    color: '#2C2C2C',
  },
  
  closeButton: {
    backgroundColor: '#F5F6FA',
    border: 'none',
    borderRadius: '8px',
    width: '40px',
    height: '40px',
    cursor: 'pointer',
    color: '#6E6E6E',
    fontSize: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease',
  },
  
  modalContent: {
    padding: '32px',
  },
  
  modalSection: {
    marginBottom: '32px',
  },
  
  sectionTitle: {
    margin: '0 0 20px 0',
    fontSize: '18px',
    fontWeight: '600',
    color: '#333333',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '20px',
  },
  
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  
  infoLabel: {
    fontSize: '13px',
    color: '#6E6E6E',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  
  infoValue: {
    fontSize: '16px',
    color: '#2C2C2C',
    fontWeight: '500',
  },
  
  durationHighlight: {
    backgroundColor: '#008FFB',
    color: '#FFFFFF',
    padding: '8px 12px',
    borderRadius: '8px',
    display: 'inline-block',
    fontWeight: '600',
  },
  
  reasonBox: {
    backgroundColor: '#F8F9FA',
    border: '1px solid #F5F6FA',
    borderLeft: '4px solid #7367F0',
    borderRadius: '12px',
    padding: '20px',
    color: '#333333',
    fontSize: '15px',
    lineHeight: '1.6',
  },
  
  attachmentBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '16px',
    backgroundColor: '#F8F9FA',
    borderRadius: '12px',
    border: '1px solid #F5F6FA',
  },
  
  attachmentIcon: {
    fontSize: '24px',
  },
  
  attachmentLink: {
    color: '#7367F0',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '15px',
  },
  
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    padding: '24px 32px',
    borderTop: '1px solid #F5F6FA',
    backgroundColor: '#F8F9FA',
    borderBottomLeftRadius: '20px',
    borderBottomRightRadius: '20px',
  },
  
  modalApproveBtn: {
    padding: '12px 24px',
    backgroundColor: '#28C76F',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '600',
    transition: 'background-color 0.2s ease',
  },
  
  modalRejectBtn: {
    padding: '12px 24px',
    backgroundColor: '#EA5455',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '600',
    transition: 'background-color 0.2s ease',
  },
  
  modalCloseBtn: {
    padding: '12px 24px',
    backgroundColor: '#6E6E6E',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '600',
    transition: 'background-color 0.2s ease',
  },
};

export default LeaveApproval;
